import { takeLatest, put, call } from 'redux-saga/effects';

import { filterPatrimonioAlertaManutencao } from '../service';
import {
  NEW_FILTER_NEXT_PAGE_PATRIMONIO_ALERTA_MANUTENCAO,
  NEW_FILTER_NEXT_PAGE_PATRIMONIO_ALERTA_MANUTENCAO_PENDING,
  NEW_FILTER_NEXT_PAGE_PATRIMONIO_ALERTA_MANUTENCAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_PATRIMONIO_ALERTA_MANUTENCAO_FAILURE,
} from '../actionTypes';
import { formatDateDDMMYYYY } from '@components/common/format';
import { CONST_FILTER_PATRIMONIO_ALERTA_MANUTENCAO } from '@commons/consts';

function* sagaNewFilterNextPagePatrimonioAlertaManutencao(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_PATRIMONIO_ALERTA_MANUTENCAO_PENDING })

  try {
    let filterSaved = sessionStorage.getItem(CONST_FILTER_PATRIMONIO_ALERTA_MANUTENCAO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PATRIMONIO_ALERTA_MANUTENCAO)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    const list = yield call(filterPatrimonioAlertaManutencao, datas, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);

    sessionStorage.setItem(CONST_FILTER_PATRIMONIO_ALERTA_MANUTENCAO, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_PATRIMONIO_ALERTA_MANUTENCAO_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {

    yield put({ type: NEW_FILTER_NEXT_PAGE_PATRIMONIO_ALERTA_MANUTENCAO_FAILURE })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterNextPagePatrimonioAlertaManutencao() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_PATRIMONIO_ALERTA_MANUTENCAO, sagaNewFilterNextPagePatrimonioAlertaManutencao)
}